// extracted by mini-css-extract-plugin
export default {"overlay":"Ty-z","bodyOpen":"Uy-z","content":"Vy-z","header":"Wy-z","close":"Xy-z","closeNoHeading":"Yy-z"};